import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../axios.js';
import { unifiedSuppressionListSchema } from '../types/unified-suppression.js';

export type UseGetAllSuppressionsParams = {
  deviceId: string;
  page: number;
  pageSize: number;
};

export function useGetAllSuppressions({ deviceId, page, pageSize }: UseGetAllSuppressionsParams) {
  return useQuery({
    queryKey: ['all-suppressions', { deviceId, page, pageSize }],
    queryFn: async () => {
      const response = await apiClient.get(`/devices/${deviceId}/all_suppressions`, {
        params: { page, pageSize },
      });
      return unifiedSuppressionListSchema.parse(response.data);
    },
    enabled: Boolean(deviceId),
  });
}
